<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'informatives-pages-container',
};
</script>
